import { CardWithAuthor } from '@hg/stylizator/components'
import * as React from 'react'

import { IAttributes } from 'app/components/CustomBlocks/component/CardWithAuthorBlock/index'

const CardWithAuthorComponent: React.FC<IAttributes> = (props) => (
  <CardWithAuthor author={props.authorName} subtitle={props.subtitle}>
    {props.text}
  </CardWithAuthor>
)

export default React.memo(CardWithAuthorComponent)
